import React, { useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import SearchInput from "../../../../common/SearchInputField";
import { ReactComponent as PlusIcon } from "../../../../../assets/images/People/Teams/plus.svg";
import TeamEditMemberRow from "./TeamEditMemberRow";
import TeamAddMembersModal from "./TeamAddMembersModal";

export default function TeamEditMembersSection({
  members,
  onMembersChange,
  agentOptions = [],
  agentsLoading = false,
  canManageMembers = true,
}) {
  const [search, setSearch] = useState("");
  const [addModalOpen, setAddModalOpen] = useState(false);

  const filtered = useMemo(() => {
    if (!search.trim()) return members;
    const q = search.toLowerCase();
    return members.filter(
      (m) =>
        (m.name || "").toLowerCase().includes(q) ||
        (m.email || "").toLowerCase().includes(q)
    );
  }, [members, search]);

  const handleRoleChange = (id, role) => {
    onMembersChange(members.map((m) => (m.id === id ? { ...m, role } : m)));
  };

  const handleRemove = (id) => {
    onMembersChange(members.filter((m) => m.id !== id));
  };

  const handleAddMembers = (picked) => {
    const existingIds = new Set(members.map((m) => m.id));
    const toAdd = picked.filter((a) => !existingIds.has(a.id));
    if (toAdd.length) onMembersChange([...members, ...toAdd]);
  };

  return (
    <Box sx={{ mt: 3 }}>
      <Typography
        sx={{
          color: "#061522",
          fontFamily: "Inter",
          fontSize: 20,
          fontWeight: 500,
          lineHeight: "34px",
          mb: 1.5,
        }}
      >
        Team Members ({members.length})
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <Box sx={{ width: 488, flex: "0 0 488px", maxWidth: "100%" }}>
          <SearchInput
            placeholder="Search team member..."
            value={search}
            className="SearchInputField-article"
            onChange={(e) => setSearch(e.target.value)}
            iconPosition="left"
            iconGap={8}
            style={{ width: 488 }}
            inputStyle={{ width: 488 }}
            noTitle
          />
        </Box>
        {canManageMembers ? (
        <Button
          onClick={() => setAddModalOpen(true)}
          sx={{
            width: 136,
            height: 40,
            minWidth: 136,
            borderRadius: "8px",
            border: "1px solid #D5DCE1",
            background: "#FFF",
            boxShadow: "0 1px 2px 0 rgba(6, 21, 34, 0.05)",
            color: "#148DFD",
            fontFamily: "Inter",
            fontSize: 14,
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal",
            textTransform: "none",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            flexShrink: 0,
            "&:hover": { background: "#FFF", borderColor: "#C5CED6", color: "#0077CC" },
          }}
        >
          <PlusIcon style={{ width: 16, height: 16, flexShrink: 0, color: "#148DFD" }} />
          Add Team
        </Button>
        ) : null}
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {filtered.map((member) => (
          <TeamEditMemberRow
            key={member.id}
            member={member}
            onRoleChange={handleRoleChange}
            onRemove={handleRemove}
            readOnly={!canManageMembers}
          />
        ))}
      </Box>

      <TeamAddMembersModal
        open={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        onApply={handleAddMembers}
        existingMemberIds={members.map((m) => m.id)}
        agentOptions={agentOptions}
        agentsLoading={agentsLoading}
      />
    </Box>
  );
}
